// extracted by mini-css-extract-plugin
export default {"componentWrapper":"LoginButton_componentWrapper__ridIH","authButton":"LoginButton_authButton__myn+d"};